"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsArray_1 = __importDefault(require("../../typeAssertions/valueIsArray"));
const valueIsNumber_1 = __importDefault(require("../../typeAssertions/valueIsNumber"));
const valueIsRecord_1 = __importDefault(require("../../typeAssertions/valueIsRecord"));
const valueIsString_1 = __importDefault(require("../../typeAssertions/valueIsString"));
const appStateSelectProjectId_1 = __importDefault(require("../../shared/appStateSelectProjectId"));
const getAccum = ({ geofire, acum, key, }) => {
    if (!(0, valueIsRecord_1.default)(geofire) || !(0, valueIsArray_1.default)(geofire.l)) {
        return acum;
    }
    const [latitude, longitude] = geofire.l;
    if (!(0, valueIsNumber_1.default)(latitude) || !(0, valueIsNumber_1.default)(longitude)) {
        return acum;
    }
    return Object.assign(Object.assign({}, acum), { [key]: {
            data: geofire.data,
            latitude,
            longitude,
        } });
};
const callableGeoFireGetAllBuilder = async ({ functionId, callbacks, executeProcesses, processor, entryVars: { groupName, }, store, }) => {
    const onError = (errorData) => {
        executeProcesses(functionId, callbacks.errorProcess, errorData);
    };
    if (!(0, valueIsString_1.default)(groupName)) {
        onError('Group name must be a string');
        return;
    }
    if (groupName.length === 0) {
        onError('Group name not must be an empty string');
        return;
    }
    const projectId = (0, appStateSelectProjectId_1.default)(store.getState());
    const geoFireGroupsRef = processor.root.firebase.database().ref(`projects/${projectId}`);
    try {
        if (groupName === 'allgroupnames') {
            const rawGeoFireGroups = (await geoFireGroupsRef.child('geoFireGroups').once('value')).val();
            const geoFiresGroups = (0, valueIsRecord_1.default)(rawGeoFireGroups) ? rawGeoFireGroups : {};
            let geofiresResult = Object.entries(geoFiresGroups)
                .reduce((acumGeo, [geoFireGroupKey, geoFireGroup]) => {
                if (!(0, valueIsRecord_1.default)(geoFireGroup)) {
                    return acumGeo;
                }
                const newGeofires = Object.entries(geoFireGroup)
                    .reduce((acum, [key, geofire]) => (getAccum({ geofire, acum, key })), {});
                return Object.assign(Object.assign({}, acumGeo), { [geoFireGroupKey]: newGeofires });
            }, {});
            const geofireRef = geoFireGroupsRef.child('geoFire');
            const rawGeofires = (await geofireRef.once('value')).val();
            const geofires = (0, valueIsRecord_1.default)(rawGeofires) ? rawGeofires : {};
            const newGeofireWithoutGroup = Object.entries(geofires || {})
                .reduce((acum, [key, geofire]) => (getAccum({ geofire, acum, key })), {});
            geofiresResult = Object.assign(Object.assign({}, geofiresResult), { withoutGroup: newGeofireWithoutGroup });
            if (!Object.keys(geofiresResult).length) {
                executeProcesses(undefined, callbacks.noDataProcess);
            }
            executeProcesses(functionId, callbacks.successProcess, geofiresResult);
            return;
        }
        const appGeofireDbRef = groupName === 'withoutgroup'
            ? processor.root.firebase.database().ref(`projects/${projectId}/geoFire`)
            : geoFireGroupsRef.child('geoFireGroups').child(`${groupName}`);
        const rawGeofires = (await appGeofireDbRef.once('value')).val();
        if (!rawGeofires) {
            executeProcesses(undefined, callbacks.noDataProcess);
        }
        const geofires = (0, valueIsRecord_1.default)(rawGeofires) ? rawGeofires : {};
        const newGeofires = Object.entries(geofires)
            .reduce((acum, [key, geofire]) => (getAccum({ geofire, acum, key })), {});
        executeProcesses(functionId, callbacks.successProcess, newGeofires);
    }
    catch (error) {
        executeProcesses(functionId, callbacks.errorProcess, `${error}`);
    }
};
exports.default = callableGeoFireGetAllBuilder;
